<template>
  <div class="error">
    <div class="title">404</div>
    <div class="message">Такой страницы не существует!</div>
    <b-button @click="$router.go(-1)" variant="primary" class="back"> Назад </b-button>
  </div>
</template>

<style lang="scss" scoped>
.error {
  width: 100%;
  height: 100%;
  background-image: url("/assets/backgrounds/error.jpg");
  background-size: cover;
  padding: 7.5rem;
  .title {
    font-size: 10rem;
    font-weight: 700;
    color: #3f4254 !important;
  }
  .message {
    font-size: 1.5rem;
    font-weight: 400;
    color: #b5b5c3 !important;
  }
  .back {
    margin-top: 3.5rem;
  }
}
</style>

<script>
export default {
  name: "Error404",
};
</script>
